import { REPORT_PACKAGE_VERSION } from '@qodana/report/lib/version'

import { CLOUD_PACKAGE_VERSION } from '../version'

export const defineQodanaVersion = (): void => {
	if (typeof window === 'undefined') {
		return
	}

	window.qodanaVersion = {
		cloud: CLOUD_PACKAGE_VERSION,
		report: REPORT_PACKAGE_VERSION,
	}
}
